const tagFields = {
  name: "Name",
  color: "Color",
};

const tagErrors = {
  TAG_IN_USE:
    "Cannot delete tag that is assigned to %{usageCount} record(s). Remove the tag from all records first.",
  deleteFailed: "Failed to delete tag",
  updateFailed: "Failed to update tag",
};

export const tag = {
  name: "Tag |||| Tags",
  label: "Tags",
  fields: {
    ...tagFields,
    domain: "Domain",
  },
  domain: {
    ticket: "Ticket",
    conversation: "Conversation",
    job_application: "Job Application",
  },
  errors: tagErrors,
};

export const ticketTag = {
  name: "Ticket Tag |||| Ticket Tags",
  fields: tagFields,
  errors: tagErrors,
};

export const conversationTag = {
  name: "Conversation Tag |||| Conversation Tags",
  fields: tagFields,
  errors: tagErrors,
};

export const jobApplicationTag = {
  name: "Job Application Tag |||| Job Application Tags",
  fields: tagFields,
  errors: tagErrors,
};
